export const TUNNUSTILAUS = 'tunnustilaus';
export const MANAGERIN_LAHETTAMA_TUNNUSTILAUS =
  'managerin_lahettama_tunnustilaus';
export const KEIKKALAISTUNNUSTILAUS = 'keikkalaistunnustilaus';
export const LUOTTAMUSHENKILOLOMAKE = 'luottamushenkilolomake';
export const LUOTTAMUSHENKILOLOMAKE2 = 'luottamushenkilolomake2';
